import { siteContent } from "../content";
const projectPartners = siteContent.projectPartners;

const ProjectPartners = () => (
  <div className="container mb-20">
    <h2 className="text-center my-20 text-5xl md:text-6xl">
      {projectPartners.title}
    </h2>
    <div className="grid grid-cols-2 md:grid-cols-6 text-center gap-5">
      <img className="col-span-2" src="/images/logos/pin.jpg" alt="pin" />
      <img
        src="/images/logos/leaders_international_logo.jpg"
        alt="Leaders International"
      />
      <img src="/images/logos/beyondgroup.jpg" alt="Beyondgroup" />
      <img src="/images/logos/MedWaves_Logo_RGB_Blue.jpg" alt="MedWaves" />
      <img
        className="max-h-14 md:max-h-20 mx-auto md:mx-0"
        src="/images/logos/injaztunisia.jpg"
        alt="Injaz Tunisia"
      />
    </div>
  </div>
);
export default ProjectPartners;
